import * as React from 'react';
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

export default function SmartDataGridToolbar(props) {
    const { toolbarColumn, toolbarFilter, toolbarDensity, toolbarExport, toolbarExportPrint, toolbarExportCsv } = props;
    return (
        <GridToolbarContainer sx={{paddingTop: 1}}>
            {toolbarColumn &&
                <GridToolbarColumnsButton />
            }
            {toolbarFilter &&
                <GridToolbarFilterButton />
            }
            {toolbarDensity &&
                <GridToolbarDensitySelector />
            }
            {toolbarExport &&
                <GridToolbarExport printOptions={{disableToolbarButton: !toolbarExportPrint}} csvOptions={{disableToolbarButton: !toolbarExportCsv}}/>
            }
        </GridToolbarContainer>
    )
}